import { useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import { Ad } from '@/api/types/common.types';
import {
  GET_MY_AD_SERVICES,
  MyAdServicesResponse,
  MyAdServicesVariables,
} from '@/features/Profile/sections/MyAds/api';
import { getMyAdsPromotionServices } from '@/features/Profile/sections/MyAds/components/MyAdsPromotionFlow/MyAdsPromotionFlow.helpers';

type Props = {
  ad: Ad | null;
  isOpen: boolean;
};

export function useMyAdsPromotionDetails({ ad, isOpen }: Props) {
  const [
    loadPromotionServices,
    { data: promotionServicesData, loading, variables },
  ] = useLazyQuery<MyAdServicesResponse, MyAdServicesVariables>(
    GET_MY_AD_SERVICES,
    { fetchPolicy: 'network-only', errorPolicy: 'all' }
  );
  const hasPromotionServicesForCurrentAd = variables?.adId === ad?.id;
  const promotionServices = hasPromotionServicesForCurrentAd
    ? promotionServicesData?.adServices
    : null;
  const adDetails =
    ad && promotionServices ? { ...ad, ...promotionServices } : null;
  const isPromotionDetailsLoading =
    loading ||
    (isOpen && !!promotionServicesData && !hasPromotionServicesForCurrentAd);
  const services = getMyAdsPromotionServices(adDetails);

  useEffect(() => {
    if (!isOpen || !ad) return;

    loadPromotionServices({
      variables: {
        adId: ad.id,
      },
    });
  }, [ad?.id, isOpen, loadPromotionServices]);

  return {
    adDetails,
    isPromotionDetailsLoading,
    services,
  };
}
